import React, { useState } from "react";
import "./AdminDeleteSucursal.css";

export default function AdminDeleteSucursal() {
  const [secret, setSecret] = useState("");
  const [sucursales, setSucursales] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [selected, setSelected] = useState(null);
  const [confirmText, setConfirmText] = useState("");
  const [backup, setBackup] = useState(true);
  const [scope, setScope] = useState("existencias");

  const loadList = async () => {
    setMessage("");
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/sucursales/list`, {
        headers: { "X-SECRET-KEY": secret }
      });
      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.detail || res.statusText);
      }
      const data = await res.json();
      setSucursales(data);
    } catch (e) {
      setMessage("Error: " + e.message);
    } finally {
      setLoading(false);
    }
  };

  const doDelete = async () => {
    if (!selected) return;
    if (confirmText !== "ELIMINAR") {
      setMessage("Escribe 'ELIMINAR' en el campo de confirmación.");
      return;
    }
    setLoading(true);
    try {
      const body = { sucursal: selected.sucursal, almacen: selected.almacen, scope, confirm: true, backup };
      const res = await fetch(`${process.env.REACT_APP_API_URL}/sucursales/delete`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json", "X-SECRET-KEY": secret },
        body: JSON.stringify(body)
      });
      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.detail || res.statusText);
      }
      const data = await res.json();
      setMessage("Eliminación completa: " + JSON.stringify(data.deleted || data));
      // recargar lista
      await loadList();
      setSelected(null);
      setConfirmText("");
    } catch (e) {
      setMessage("Error: " + e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-delete">
      <h2>Eliminar Sucursales</h2>

      <div className="form-row">
        <input type="password" placeholder="Clave secreta" value={secret} onChange={e => setSecret(e.target.value)} />
        <button onClick={loadList} disabled={loading}>{loading ? 'Cargando...' : 'Cargar sucursales'}</button>
      </div>

      {message && <div className={`message ${message.startsWith('Error') ? 'error' : 'info'}`}>{message}</div>}

      <div className="sucursal-list" style={{ maxHeight: 300, overflowY: 'auto' }}>
        {sucursales.length === 0 && <div className="sucursal-item">No hay sucursales cargadas (o no autorizado).</div>}
        {sucursales.map((s, i) => (
          <div key={i} className="sucursal-item">
            <div>
              <strong>{s.sucursal}</strong> — {s.almacen} <span style={{ color: '#777' }}>({s.productos_count} productos)</span>
            </div>
            <div>
              <button onClick={() => setSelected(s)}>Eliminar</button>
            </div>
          </div>
        ))}
      </div>

      {selected && (
        <div className="confirm-panel">
          <h3>Confirmar eliminación</h3>
          <div style={{ textAlign: 'center', marginBottom: 8 }}>Sucursal: <b>{selected.sucursal}</b> — {selected.almacen}</div>

          <div className="confirm-row">
            <label>Alcance: </label>
            <select value={scope} onChange={e => setScope(e.target.value)}>
              <option value="existencias">Existencias</option>
              <option value="ventas">Ventas</option>
              <option value="all">Todo (Existencias + Ventas)</option>
            </select>
          </div>

          <div className="confirm-row">
            <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}><input type="checkbox" checked={backup} onChange={e => setBackup(e.target.checked)} /> Hacer respaldo antes de borrar</label>
          </div>

          <div className="confirm-row">
            Escribe <b>ELIMINAR</b> para confirmar: <input value={confirmText} onChange={e => setConfirmText(e.target.value)} />
          </div>

          <div className="confirm-actions">
            <button className="btn-primary" onClick={doDelete} disabled={loading}>{loading ? 'Eliminando...' : 'Ejecutar eliminación'}</button>
            <button className="btn-secondary" onClick={() => { setSelected(null); setConfirmText(''); }}>Cancelar</button>
          </div>
        </div>
      )}

      <div className="footer-help">Atención: las operaciones quedan registradas en el sistema y se recomienda hacer backup antes de borrar.</div>
    </div>
  );
}
